"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLocationType = exports.OfferingLocationType = void 0;
var OfferingLocationType;
(function (OfferingLocationType) {
    OfferingLocationType["CUSTOMER"] = "CUSTOMER";
    OfferingLocationType["BUSINESS"] = "BUSINESS";
    OfferingLocationType["OTHER"] = "OTHER";
})(OfferingLocationType = exports.OfferingLocationType || (exports.OfferingLocationType = {}));
var ServiceLocationType;
(function (ServiceLocationType) {
    ServiceLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    ServiceLocationType["CLIENT_PLACE"] = "CLIENT_PLACE";
    ServiceLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
})(ServiceLocationType = exports.ServiceLocationType || (exports.ServiceLocationType = {}));
//# sourceMappingURL=offering-location.dto.js.map